import { suggestionsFailure, suggestionsRequest, suggestionsSuccess } from './actions';
import { resolveSuggestions } from '../../services/suggestions';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Redux action, который запрашивает саджесты
 */
export const suggestionsRequestAction =
  (query: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi, custom }) => {
    const { subdomain } = custom;

    try {
      dispatch(suggestionsRequest());

      const newData = await resolveSuggestions({
        httpApi,
        logger,
        query,
        subdomain,
      });

      dispatch(suggestionsSuccess(newData));
    } catch (e) {
      dispatch(suggestionsFailure());
    }
  };
